import { Attachment } from '@billy/design-system'

import { AttachmentFillType } from '@features/attachments/enums/attachmentFillType'
import { useFetchAttachments } from '@features/attachments/hooks/useFetchAttachments'
import { AttachmentFilters } from '@features/attachments/types/attachmentFilters'
import { getAttachmentsApiFilter } from '@features/attachments/utils/getAttachmentsApiFilter'
import { useIsEInvoicingOnly } from '@features/bills/hooks/useIsEInvoicingOnly'

import { useOrgUsesReceiptsOnly } from '../../../hooks/useOrgUsesReceiptsOnly'
import { Paging } from '../../../types/metable'
import { SHOEBOX_ATTACHMENTS_INCLUDE } from '../constants/shoeboxAttachmentsInclude'
import { defaultAttachmentsQuery } from './useAttachmentsFilters'

interface UseAttachmentsResponse {
  attachments: Attachment[]
  pagination?: Paging
  isLoading: boolean
}

export const useAttachments = ({
  type,
  page,
  sortBy,
  sortDirection,
  searchQuery,
}: AttachmentFilters = defaultAttachmentsQuery): UseAttachmentsResponse => {
  const orgUsesReceiptsOnly = useOrgUsesReceiptsOnly()
  const isEInvoicingOnly = useIsEInvoicingOnly()
  const { type: apiType, eInvoiceFilter } = getAttachmentsApiFilter(type, orgUsesReceiptsOnly, isEInvoicingOnly)

  const { attachments, isLoading, pagination } = useFetchAttachments({
    eInvoiceFilter,
    page,
    searchQuery,
    sortBy,
    sortDirection,
    fillType: orgUsesReceiptsOnly ? undefined : AttachmentFillType.Nonfilled,
    include: orgUsesReceiptsOnly ? SHOEBOX_ATTACHMENTS_INCLUDE : undefined,
    type: apiType,
  })

  return {
    attachments,
    isLoading,
    pagination,
  }
}
